import React from 'react';
import { Helmet } from 'react-helmet-async';
import NewsDetail from '../components/NewsDetail';

const NewsDetail_en = () => (
  <div className="lang-en">
    <Helmet>
      <title>News Detail</title>
      <meta
        name="description"
        content="Read the full English version of Tang Wu Biotech news and announcements."
      />
      <meta name="keywords" content="news detail, Tang Wu, announcements" />
    </Helmet>
    <NewsDetail />
  </div>
);

export default NewsDetail_en;
